import script from "./vipRule.vue?vue&type=script&setup=true&lang=js"
export * from "./vipRule.vue?vue&type=script&setup=true&lang=js"

import "./vipRule.vue?vue&type=style&index=0&id=a0c6a6ae&lang=less&scoped=true"

import exportComponent from "/data/jenkins_home/workspace/prod-AI-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0c6a6ae"]])

export default __exports__